import { Box, Tooltip } from '@mui/material';
import { IdentityAvatar } from './IdentityAvatar';
import { designTokens } from '../tokens';

export type IdentityAvatarGroupProps = {
  items: readonly { id: string; name: string; src?: string }[];
  max?: number;
  /** 일부만 조회한 경우 접근 가능한 전체 대상 수를 전달합니다. */
  total?: number;
  size?: 24 | 32;
  ariaLabel?: string;
};

/** 표시 한도를 넘는 대상을 +N으로 요약합니다. 개인정보와 정렬은 소비자가 결정합니다. */
export function IdentityAvatarGroup({ items, max = 4, total = items.length, size = 24, ariaLabel }: IdentityAvatarGroupProps) {
  const visible = items.slice(0, Math.max(1, Math.floor(max)));
  const remaining = Math.max(total, items.length) - visible.length;
  if (!items.length) return null;
  const summary = ariaLabel ?? `${visible.map(item => item.name).join(', ')}${remaining ? ` 외 ${remaining}명` : ''}`;
  const avatarSx = { boxSizing: 'content-box', border: `2px solid ${designTokens.color.canvas}` } as const;
  return <Box component="span" role="img" aria-label={summary} sx={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0, '& > span + span': { ml: '-6px' } }}>
    {visible.map(item => <Tooltip key={item.id} title={item.name}><Box component="span" sx={{ display: 'inline-flex' }}>
      <IdentityAvatar size={size} src={item.src} alt="" aria-hidden="true" slotProps={{ img: { loading: 'lazy' } }} sx={avatarSx}>{Array.from(item.name.trim())[0] ?? '?'}</IdentityAvatar>
    </Box></Tooltip>)}
    {remaining > 0 && <Tooltip title={`${remaining}명 더`}><Box component="span" sx={{ display: 'inline-flex' }}>
      <IdentityAvatar size={size} aria-hidden="true" sx={{ ...avatarSx, bgcolor: designTokens.color.subtleSurface, color: designTokens.color.secondaryText }}>+{remaining}</IdentityAvatar>
    </Box></Tooltip>}
  </Box>;
}
